export default [{
        name: "AskReddit",
        isStarred: false,
        id: 0
    },
    {
        name: "all",
        isStarred: false,
        id: 1
    },
    {
        name: "RocketLeague",
        isStarred: false,
        id: 2
    },
    {
        name: "pics",
        isStarred: false,
        id: 3
    },
    {
        name: "reactjs",
        isStarred: false,
        id: 4
    },
    {
        name: "videos",
        isStarred: false,
        id: 5
    }
];